<template>
  <v-select class="w-full" 
    v-model="provincia" 
    :options="provincias" 
    label="nombre"
    @input="$emit('input', provincia)"
    :disabled="disabled"
    :reduce="id => `/api/val_provincias/${id.id}`" 
  />
</template>

<script>
import vSelect from 'vue-select'
import commonComponentsStore from '@/store/common-components/index.js'

export default {
  components: {
    'v-select': vSelect
  },
  props: {
    provinciaSelected: String,
    disabled: Boolean
  },
  data () {
    return {
      provincia: (this.provinciaSelected !== null && this.provinciaSelected !== undefined) ? JSON.parse(JSON.stringify(this.provinciaSelected)) : null,
      provincias: []
    }
  },
  watch: {
    provinciaSelected () {
      this.provincia = this.provinciaSelected
    }
  },
  methods: {
    cambiarEstado (estado) {
      this.disabled = estado // true ou false
    }
  },
  async created () {
    if (!commonComponentsStore.isRegistered) {
      this.$store.registerModule('commonComponentsStore', commonComponentsStore)
      commonComponentsStore.isRegistered = true
    }
    this.provincias = this.$store.state.commonComponentsStore.provincias
  }
}
</script>

<style>

</style>